module.exports = __webpack_public_path__ + "img/give_away_submitted.a7e28079.png";